//console.log('digioh discount js');
document.addEventListener("readystatechange", function (event) {
  //Function to save the appropriate discount code
    function discountReady() {
        if(document.body.contains(document.querySelector('.total-price-with-currency'))) {
            var digiohTotal = document.querySelector('.total-price-with-currency').innerText;
            var sanitizedTotal = parseInt(digiohTotal.replace(/[^a-zA-Z0-9 ]/g, '').split(' ').join(''));
            var mbDiscount;

          //if (window.location.href.indexOf("quiz-results-buck?") != -1){
            
            if (sanitizedTotal > 1) {
              function setDiscount() {
                //Parse cookie into an array of objects
                var discArray = JSON.parse(getCookie('mb_quiz_disc_thresholds'))
                discArray = discArray.filter((obj) => parseInt(obj.threshold) <= sanitizedTotal);
               //Set initial value for max discount and loop over array to end with the max discount to be set
                var max_discount = discArray[0];
                discArray.forEach(obj => {
                  obj.threshold > max_discount.threshold ? max_discount = obj : max_discount = max_discount;
                })
                //If the array is empty apply no discount else set the discount code
                mbDiscount = !discArray.length ? "No-Discount" : max_discount.code;
                sessionStorage.setItem("quiz-discount", mbDiscount);
              }
              setDiscount();
            } else {
              setTimeout(() => {
                discountReady();
              }, "500");
            }
          //}

            
          //to be removed
          /*
          else if (sanitizedTotal > 1) {
                    function setDiscount() {
                switch(true) {
                case (150000 <= sanitizedTotal): 
                    mbDiscount = 'QUIZ-H25ERWP4KG3B' 
                    break;
                case (120000 <= sanitizedTotal &&  sanitizedTotal < 150000): 
                    mbDiscount = 'QUIZ-Z7SBNTRVHNNJ' 
                    break;
                case (110000 <= sanitizedTotal &&  sanitizedTotal < 120000): 
                    mbDiscount = 'QUIZ-VT39EEA38J2B' 
                    break;
                default: mbDiscount = "No-Discount"
                }
                sessionStorage.setItem("quiz-discount", mbDiscount);
                //console.log("session storage set");
            }
                    setDiscount();
          }
  
          else {
            setTimeout(() => {
            discountReady();
                //console.log("Price not set: "+sanitizedTotal);
            }, "500");
          }
      */
        //remove to here


        }
        else {
            setTimeout(() => {
            discountReady();
            }, "500");
        }
    };
    
    function quizObserver() {
      if(document.body.contains(document.querySelector('.flickity-slider'))) {
        const targetNode = document.querySelector(".flickity-slider");
        // Options for the observer (which mutations to observe)
        const config = { childList: true };
        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                discountReady();
            }
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
        discountReady();
      } else {
        setTimeout(() => {
        quizObserver();
        }, "500");
      }
    }
  quizObserver();
});
